import React from 'react';
import classNames from 'classnames';

export const NavLinkLabel = ({
  className,
  ...rest
}: React.HTMLAttributes<HTMLSpanElement>) => (
  <span {...rest} className={classNames('text-break', className)} />
);
